import * as React from 'react'
import { Text, padding, spacing } from '@thg-commerce/gravity-theme'
import { styled } from '../theme'
import { ProductDescriptionAccordionProps } from './types'

const downloadPadding = {
  top: 1,
  right: 1,
  bottom: 2,
  left: 1,
}

const Container = styled.div`
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
`

const Item = styled.div`
  ${Text('bodyText', 'default')};
  &:nth-last-child(-n + 1) {
    margin-bottom: ${spacing(2)};
  }
  text-decoration: none;
`

const ProductManualStyle = styled.a`
  ${(props) =>
    props.theme.patterns.productDescriptionAccordion.download.padding
      ? padding(
          props.theme.patterns.productDescriptionAccordion.download.padding,
        )
      : padding(downloadPadding)}
  color: ${(props) =>
    props.theme.patterns.productDescriptionAccordion.download.textColor
      ? props.theme.patterns.productDescriptionAccordion.download.textColor
      : '#1d8634'};
  display: inline;
  &:hover {
    text-decoration: underline;
  }
  &:not(:hover) {
    text-decoration: none;
  }
`

export const Downloads: React.FunctionComponent<{
  downloads: Required<ProductDescriptionAccordionProps['downloads']>
}> = (props) => {
  if (!props.downloads) {
    return null
  }

  return (
    <Container>
      {props.downloads.items?.map((item) => {
        return (
          <Item>
            <ProductManualStyle href={item.value} download>
              {item.title}
            </ProductManualStyle>
          </Item>
        )
      })}
    </Container>
  )
}
